export default {
	//
	// components
	//

	//
	// RenewToken
	//
	RenewToken_dialogTitle: "Refresh Access",
	RenewToken_header1: "Uh-oh.",
	RenewToken_header2: "Teaming lost connection with your calendar",
	RenewToken_content: "Don’t worry! We can fix this together. Click the ‘Refresh Access’ button to re-authorize Teaming and we will be back up and running in seconds.",
	RenewToken_btnText: "Refresh Access",
};



// WEBPACK FOOTER //
// ./src/lang/en/session.js